export class MainNavigation {
  private _navigationItems = [];

  get items() {
    return this._navigationItems;
  }
}
